// @flow
import React from 'react';
import {Scrollbar} from 'react-scrollbars-custom';
import styles from './styles.local.less';

type TProps = {
    children: React$Node,
    style?: {
        [key: string]: string,
    },
};

/**
 * Компонент Скролбара
 * @return {*} Компонент Скролбара
 */
function CustomScrollbars({children, style}: TProps) {
    const customScrollBarVertical = React.useCallback(
        ({elementRef, ...restProps}) => <span {...restProps} className={styles.customScrollBarVertical} ref={elementRef} />,
        []
    );
    const customScrollBarVerticalThumb = React.useCallback(
        ({elementRef, ...restProps}) => <span {...restProps} className={styles.customScrollBarVerticalThumb} ref={elementRef} />,
        []
    );
    const customScrollBarVerticalTrack = React.useCallback(
        ({elementRef, ...restProps}) => (
            <span className={styles.customScrollBarVerticalTrackContainer}>
                <span {...restProps} className={styles.customScrollBarVerticalTrack} ref={elementRef} />
            </span>
        ),
        []
    );
    const customScrollBarVerticalWrapper = React.useCallback(
        ({elementRef, ...restProps}) => <span {...restProps} className={styles.customScrollBarVerticalWrapper} ref={elementRef} />,
        []
    );

    return (
        <Scrollbar
            noDefaultStyles
            renderer={customScrollBarVertical}
            style={style}
            thumbYProps={{
                renderer: customScrollBarVerticalThumb,
            }}
            trackYProps={{
                renderer: customScrollBarVerticalTrack,
            }}
            wrapperProps={{
                renderer: customScrollBarVerticalWrapper,
            }}
        >
            {children}
        </Scrollbar>
    );
}
export {CustomScrollbars};
